import { FC } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'

import HistoricModal, {
  HISTORIC_COLUMNS
} from '@component/Parameterization/Shared/HistoricModal'

import ParametroCompra from '@service/ParametroCompra'

const ModalHistoricPurchaseTolerancia: FC = () => {
  const { companieId } = useParametrizationConfigPurchase()
  return (
    <HistoricModal
      title="Histórico Tolerância de Compras"
      empresaId={companieId}
      fetcher={async empresaId =>
        (await ParametroCompra.getToleranciaQuantidadeHistorico(empresaId)).data
          ?.data ?? []
      }
      columns={[
        HISTORIC_COLUMNS.data,
        HISTORIC_COLUMNS.usuario,
        HISTORIC_COLUMNS.empresa,
        HISTORIC_COLUMNS.acao
      ]}
      emptyMessage="Nenhum histórico de tolerância encontrado para esta empresa."
    />
  )
}

export default ModalHistoricPurchaseTolerancia
